import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import {
  COLOR_BANNER_VISIBLE_MENU,
  LIST_CHANNEL_OPTION,
  LIST_OPTION_BANNER_VISIBLE_MENU,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea } from "helpers/format";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import CollapseFilter from "components/Common/CollapseFilter";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import ModalPreview from "components/Common/ModalPreview";
import BannerForm from "./BannerForm";
import CopyWrapper from "components/Common/CopyWrapper";
import ModalPreviewQRCode from "components/Common/ModalPreviewQRCode";
import { getBannerPositionList } from "store/banner-position/thunk";
import bannerApi from "api/bannerApi";
import { getBannerList, putBanner } from "store/banner/thunk";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";

registerLocale("en", en);
registerLocale("ko", ko);

const BannerPremium = () => {
  const { t, i18n } = useTranslation();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    name: withDefault(StringParam, ""),
    positionCode: withDefault(StringParam, ""),
    visibleInMenu: withDefault(StringParam, ""),
    // sortBy: withDefault(StringParam, "createdAt"),
    // orderBy: withDefault(StringParam, "desc"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [previewQRCode, setPreviewQRCode] = useState<any>(null);

  const [nameSearch, setNameSearch] = useState<string>(query?.name || "");
  const [positionCodeSearch, setPositionCodeSearch] = useState<string>(
    query?.positionCode || ""
  );
  const [visibleInMenuSearch, setVisibleInMenuSearch] = useState<Option | any>(
    LIST_CHANNEL_OPTION?.find((item) => item?.value === query?.visibleInMenu)
      ?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Banner;
  const BannerPositionProperties = createSelector(
    selectLayoutState,
    (state) => ({
      lstBanner: state.lstBanner,
      isBannerLoading: state.isBannerLoading,
      isBannerSuccess: state.isBannerSuccess,
      error: state.error,
    })
  );

  // Inside your component
  const { lstBanner, isBannerLoading } = useSelector(BannerPositionProperties);

  function loadTableData() {
    dispatch(getBannerList(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      name: nameSearch,
      positionCode: positionCodeSearch,
      visibleInMenu: visibleInMenuSearch,
      sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        name: "",
        positionCode: "",
        visibleInMenu: "",
        sortBy: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setNameSearch((_prev) => "");
    setPositionCodeSearch((_prev: any) => "");
    setVisibleInMenuSearch((_prev: any) => "");
  };

  const handleOnConfirmUpdate = async (item: {
    data: any;
    status: string | boolean;
  }) => {
    if (!item || !item?.data?.id) return;

    try {
      const formatData = {
        status: item?.status,
      };
      const response: any = await putBanner(item?.data?.id, formatData);
      if (response?.code === 200) {
        loadTableData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        Cell: ({ ...props }) => {
          return (
            <div style={{ minWidth: "60px" }}>
              {lstBanner?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        filterable: false,
        sortable: false,
        thWidth: 100,
        thClass: "align-middle text-center",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
              style={{ maxWidth: "120px" }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="status"
                checked={cell?.value === "ACTIVE" ? true : false}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({
                    data: item,
                    status: value === true ? "ACTIVE" : "INACTIVE",
                  });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Exposure Start"),
        accessor: "startTime",
        thWidth: 150,
        thClass: "whitespace-nowrap text-end",
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer text-end">
              {cell?.value
                ? formatDateStringToKorea(cell?.value, "YYYY-MM-DD")
                : "-"}
            </div>
          );
        },
      },
      {
        Header: t("Exposure End"),
        accessor: "endTime",
        thWidth: 150,
        thClass: "whitespace-nowrap text-end",
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer text-end">
              {cell?.value
                ? formatDateStringToKorea(cell?.value, "YYYY-MM-DD")
                : "-"}
            </div>
          );
        },
      },
      {
        Header: t("Premium Banner Placement"),
        accessor: "premiumBannerPlacement",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          let visibleInMenu = cell?.value;

          return (
            <div className="text-center">
              <span
                className={`rounded-pill badge bg-${
                  COLOR_BANNER_VISIBLE_MENU[visibleInMenu] || "secondary"
                }`}
              >
                {t(
                  LIST_OPTION_BANNER_VISIBLE_MENU?.find(
                    (i) => i?.value === visibleInMenu
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Additional Section Exposure"),
        accessor: "additionalSectionExposure",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          let visibleInMenu = cell?.value;

          return (
            <div className="text-center">
              <span
                className={`rounded-pill badge bg-${
                  COLOR_BANNER_VISIBLE_MENU[visibleInMenu] || "secondary"
                }`}
              >
                {t(
                  LIST_OPTION_BANNER_VISIBLE_MENU?.find(
                    (i) => i?.value === visibleInMenu
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updatedAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, lstBanner?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await bannerApi?.deleteBannerPosition(id);
      if (response?.code === 200 && response?.message === "Success") {
        setItemToDelete(false);
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        toast(
          `${t("The banner position has been deleted.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const onCloseQRCodeClick = () => {
    setPreviewQRCode(null);
  };

  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    loadTableData();
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Banner Premium")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Banner Premium")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-5 con-sm-6">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={lstBanner?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    <div className="col-7 con-sm-6 text-end">
                      <div className="col-sm-auto">
                        <div>
                          <button
                            type="button"
                            className="btn btn-success add-btn"
                            onClick={() => {
                              setIsOpen(true);
                              setItemToEdit(null);
                            }}
                          >
                            <i className="ri-add-line align-bottom me-1"></i>
                            {t("Create Banner Premium")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Row>
                </CardHeader>

                {/* <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Name")} isShow={!!nameSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Name")}...`}
                            value={nameSearch}
                            onChange={(e) => setNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Position Code")}
                          isShow={!!positionCodeSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Position Code")}...`}
                            value={positionCodeSearch}
                            onChange={(e) =>
                              setPositionCodeSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Visible In Menu")}
                          isShow={true}
                        >
                          <DropdownStatusNew
                            name="visibleInMenu"
                            placeholder={`${t("Visible In Menu")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            dataList={LIST_OPTION_BANNER_VISIBLE_MENU}
                            initialValue={visibleInMenuSearch}
                            onChangeSelect={(e: any) => {
                              setVisibleInMenuSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_BANNER_VISIBLE_MENU}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-3 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div> */}
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={lstBanner?.items?.length ? lstBanner?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={lstBanner?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(lstBanner?.pagination?.total) /
                          Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isBannerLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <BannerForm
            setIsOpen={setIsOpen}
            id={itemToEdit?.id}
            item={itemToEdit}
            setItemToEdit={setItemToEdit}
            triggerRefresh={triggerRefresh}
            setLinkImage={setLinkImage}
          />
        )}

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Banner Premium")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {previewQRCode && (
          <ModalPreviewQRCode
            itemQRCode={previewQRCode}
            onCloseQRCodeClick={onCloseQRCodeClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default BannerPremium;
